// kontakt/index.jsx

import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  useTheme,
  useMediaQuery,
  InputAdornment,
  Grid,
  FormHelperText,
} from '@mui/material';
import Navbar from 'scenes/widgets/navbar';
import Footer from 'scenes/widgets/footer';

const KontaktPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:999px)');

  useEffect(() => {
    const loadHubSpotForm = () => {
      if (document.getElementById('hs-script-loader')) {
        initializeHubSpotForm();
        return;
      }

      const script = document.createElement('script');
      script.id = 'hs-script-loader';
      script.src = 'https://js.hsforms.net/forms/embed/v2.js';
      script.async = true;
      script.defer = true;

      document.body.appendChild(script);

      script.onload = () => {
        initializeHubSpotForm();
      };
    };

    const initializeHubSpotForm = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '7390332',
          formId: '9519ca39-0a25-4f71-be32-3369dad71f2d',
          target: '#hubspot-form',
          onFormReady: function () {
            insertMissingText();
            implementConditionalRequiredFields();

            const formIframe = document.querySelector('.hs-form-iframe');
            if (formIframe) {
              const iframeDocument = formIframe.contentDocument || formIframe.contentWindow.document;
              const submissionUrlField = iframeDocument.querySelector('input[name="submission_url"]');
              if (submissionUrlField) {
                submissionUrlField.value = window.location.href;
              }

              // 1. Hide the hs_recaptcha element
              const recaptcha = iframeDocument.querySelector('.hs_recaptcha');
              if (recaptcha) {
                recaptcha.style.display = 'none';
              }

              // 2. Center the submit button
              const actionsDiv = iframeDocument.querySelector('.actions');
              // if (actionsDiv) {
              //   actionsDiv.style.display = 'flex';
              //   actionsDiv.style.justifyContent = 'center';
              // }

              // 3. Move "*Pflichtfelder" before the submit button
              const pflichtfelderText = iframeDocument.createElement('p');
              pflichtfelderText.textContent = '*Pflichtfelder';
              pflichtfelderText.style.fontFamily = 'Rubik, sans-serif';
              actionsDiv.parentNode.insertBefore(pflichtfelderText, actionsDiv);

              // 4. Center the submitted-message text
              // const submittedMessage = iframeDocument.querySelector('.submitted-message');
              // if (submittedMessage) {
              //   submittedMessage.style.textAlign = 'center';
              // }

              const style = iframeDocument.createElement('style');
              style.textContent = `
                .submitted-message {
                  text-align: center;
                }
              `;
              iframeDocument.head.appendChild(style);

              // 5. Move "Jetzt hier Eintragen" into the iframe
              // const jetztEintragenText = iframeDocument.createElement('h5');
              // const hbsptform = iframeDocument.querySelector('.hbspt-form')
              // jetztEintragenText.textContent = 'Jetzt hier Eintragen';
              // jetztEintragenText.style.fontFamily = 'Rubik, sans-serif';
              // jetztEintragenText.style.fontSize = "1rem";
              // jetztEintragenText.style.textAlign = "center";
              // hbsptform.insertBefore(jetztEintragenText, hbsptform.firstChild);
            }
          },
          onFormSubmitted: function () {
          document.cookie = "formSubmitted=true; path=/; max-age=31536000";
          },
        });
      }
    };

    const insertMissingText = () => {
      const formIframe = document.querySelector('.hs-form-iframe');
      if (!formIframe) return;
    
      const iframeDocument = formIframe.contentDocument || formIframe.contentWindow.document;
      const emailField = iframeDocument.querySelector('div.hs-email');
    
      if (emailField) {
        const missingText = iframeDocument.createElement('p');
        missingText.textContent = '...oder tragen Sie Ihr Unternehmen gleich mit ein';
        missingText.style.marginTop = '20px';
        missingText.style.fontWeight = 'bold';
        missingText.style.fontFamily = 'Rubik, sans-serif';
        // missingText.style.fontSize = '13px';
        emailField.parentNode.insertBefore(missingText, emailField.nextSibling);
      }
    };

    const implementConditionalRequiredFields = () => {
      const formIframe = document.querySelector('.hs-form-iframe');
      
      if (!formIframe) {
        console.error('Form iframe not found');
        return;
      }
    
      const iframeDocument = formIframe.contentDocument || formIframe.contentWindow.document;
    
      const companyField = iframeDocument.querySelector('input[name="0-2/name"]');
      const websiteField = iframeDocument.querySelector('input[name="0-2/website"]');
      const locationField = iframeDocument.querySelector('input[name="0-2/city"]');
    
      const addAsteriskToLabel = (labelId) => {
        const label = iframeDocument.getElementById(labelId);
        if (label) {
          if (!label.querySelector('.hs-form-required')) {
            const span = label.querySelector('span');
            const asterisk = iframeDocument.createElement('span');
            asterisk.className = 'hs-form-required';
            asterisk.textContent = '*';
            if (span) {
              span.parentNode.insertBefore(asterisk, span.nextSibling);
            }
          }
        }
      };
    
      const removeAsteriskFromLabel = (labelId) => {
        const label = iframeDocument.getElementById(labelId);
        if (label) {
          const asterisk = label.querySelector('.hs-form-required');
          if (asterisk) {
            asterisk.remove();
          }
        }
      };
    
      const addErrorMessage = (field) => {
        const fieldContainer = field.closest('.hs-form-field');
        if (fieldContainer) {
          field.classList.add('error');
          field.style.borderColor = '#c87872';
    
          let errorContainer = fieldContainer.querySelector('.hs-error-msgs');
          if (!errorContainer) {
            errorContainer = iframeDocument.createElement('ul');
            errorContainer.className = 'hs-error-msgs inputs-list';
            const errorItem = iframeDocument.createElement('li');
            const errorLabel = iframeDocument.createElement('label');
            errorLabel.className = 'hs-error-msg';
            errorLabel.textContent = 'Bitte füllen Sie dieses Pflichtfeld aus.';
            errorItem.appendChild(errorLabel);
            errorContainer.appendChild(errorItem);
            fieldContainer.appendChild(errorContainer);
          }
          fieldContainer.classList.add('hs-error');
        }
      };
    
      const removeErrorMessage = (field) => {
        const fieldContainer = field.closest('.hs-form-field');
        if (fieldContainer) {
          field.classList.remove('error');
          field.style.borderColor = '';
    
          const errorContainer = fieldContainer.querySelector('.hs-error-msgs');
          if (errorContainer) {
            errorContainer.remove();
          }
          fieldContainer.classList.remove('hs-error');
        }
      };
    
      const toggleRequired = () => {
        const isAnyFieldFilled =
          companyField.value.trim() !== '' ||
          websiteField.value.trim() !== '' ||
          locationField.value.trim() !== '';

        if (isAnyFieldFilled) {
          companyField.setAttribute('data-required', 'true');
          websiteField.setAttribute('data-required', 'true');
          locationField.setAttribute('data-required', 'true');

          addAsteriskToLabel('label-0-2/name-9519ca39-0a25-4f71-be32-3369dad71f2d');
          addAsteriskToLabel('label-0-2/website-9519ca39-0a25-4f71-be32-3369dad71f2d');
          addAsteriskToLabel('label-0-2/city-9519ca39-0a25-4f71-be32-3369dad71f2d');

          if (!companyField.value.trim()) {
            addErrorMessage(companyField);
          }
          if (!websiteField.value.trim()) {
            addErrorMessage(websiteField);
          }
          if (!locationField.value.trim()) {
            addErrorMessage(locationField);
          }
        } else {
          companyField.removeAttribute('data-required');
          websiteField.removeAttribute('data-required');
          locationField.removeAttribute('data-required');

          removeAsteriskFromLabel('label-0-2/name-9519ca39-0a25-4f71-be32-3369dad71f2d');
          removeAsteriskFromLabel('label-0-2/website-9519ca39-0a25-4f71-be32-3369dad71f2d');
          removeAsteriskFromLabel('label-0-2/city-9519ca39-0a25-4f71-be32-3369dad71f2d');

          removeErrorMessage(companyField);
          removeErrorMessage(websiteField);
          removeErrorMessage(locationField);
        }
      };
    
      // Initial check
      toggleRequired();
    
      companyField.addEventListener('input', toggleRequired);
      websiteField.addEventListener('input', toggleRequired);
      locationField.addEventListener('input', toggleRequired);
    
      companyField.addEventListener('input', function () {
        if (websiteField.value.trim() !== '' || locationField.value.trim() !== '') {
          if (this.value.trim()) {
            removeErrorMessage(this);
          } else {
            addErrorMessage(this);
          }
        }
      });

      websiteField.addEventListener('input', function () {
        if (companyField.value.trim() !== '' || locationField.value.trim() !== '') {
          if (this.value.trim()) {
            removeErrorMessage(this);
          } else {
            addErrorMessage(this);
          }
        }
      });

      locationField.addEventListener('input', function () {
        if (companyField.value.trim() !== '' || websiteField.value.trim() !== '') {
          if (this.value.trim()) {
            removeErrorMessage(this);
          } else {
            addErrorMessage(this);
          }
        }
      });
    
      // Form submission handler
      const form = iframeDocument.querySelector('form');
      if (form) {
        form.addEventListener('submit', (event) => {
          const isAnyFieldFilled =
            companyField.value.trim() !== '' ||
            websiteField.value.trim() !== '' ||
            locationField.value.trim() !== '';

          if (isAnyFieldFilled) {
            const isCompanyEmpty = !companyField.value.trim();
            const isWebsiteEmpty = !websiteField.value.trim();
            const isLocationEmpty = !locationField.value.trim();

            if (isCompanyEmpty || isWebsiteEmpty || isLocationEmpty) {
              event.preventDefault();
              event.stopPropagation();

              if (isCompanyEmpty) {
                addErrorMessage(companyField);
              }
              if (isWebsiteEmpty) {
                addErrorMessage(websiteField);
              }
              if (isLocationEmpty) {
                addErrorMessage(locationField);
              }

              return false;
            }
          }
        }, true);
      }
    };

    const currentPath = window.location.pathname;
    const currentQuery = window.location.search;

    // loadHubSpotForm();

    if (currentPath === '/kontakt' && currentQuery !== '?Kontaktaufnahme') {
      loadHubSpotForm();
    }

    function loadTrackingScript() {
      const trackingScript = document.createElement('script');
      trackingScript.type = 'text/javascript';
      trackingScript.id = 'hs-script-loader-tracking';
      trackingScript.async = true;
      trackingScript.defer = true;
      trackingScript.src = '//js.hs-scripts.com/7390332.js';
      document.body.appendChild(trackingScript);
    }

    if (currentPath === '/kontakt' && currentQuery === '?Kontaktaufnahme') {
        loadTrackingScript();

        if (localStorage.getItem('cookiesAccepted') === 'true') {
          loadHubSpotForm();
          return
        }

        const styleEl = document.createElement('style');
        styleEl.innerHTML = `
          /* Center the cookie banner */
          #hs-eu-cookie-confirmation {
            position: fixed !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%) !important;
            z-index: 99999 !important;
            background: #fff !important;
            padding: 20px !important;
            border-radius: 8px !important;
            box-shadow: 0 2px 10px rgba(0,0,0,0.3) !important;
            display: flex !important;
            align-items: center !important;
            width: auto !important;
          }

          @media (max-width: 768px) {
            #hs-eu-cookie-confirmation {
              width: 100% !important;
            }
          }

          div#hs-eu-cookie-confirmation.hs-cookie-notification-position-bottom {
            bottom: unset !important;
          }

          div#hs-eu-cookie-confirmation div#hs-eu-cookie-confirmation-inner div#hs-en-cookie-confirmation-buttons-area {
            margin-right: 0px !important;
            justify-content: center !important;
          }

          /* Ensure inner text is centered nicely */
          #hs-eu-cookie-confirmation-inner {
            text-align: center;
          }

          /* The dimmed background overlay */
          #cookie-overlay {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100% !important;
            height: 100% !important;
            background-color: rgba(0, 0, 0, 0.5) !important;
            z-index: 99998 !important;
          }

          /*
            Blur and block interaction on everything except
            the cookie banner when it is visible.
          */
          body.cookie-banner-visible *:not(#hs-eu-cookie-confirmation, 
                                          #hs-eu-cookie-confirmation *, 
                                          #cookie-overlay) {
            filter: blur(2px);
            pointer-events: none;
            user-select: none;
          }

          #hs-eu-decline-button {
            display: none !important;
          }
        `;
        document.head.appendChild(styleEl);

        const overlay = document.createElement('div');
        overlay.id = 'cookie-overlay';
        document.body.appendChild(overlay);

        document.body.classList.add('cookie-banner-visible');

        function hideCookieBanner() {
          localStorage.setItem('cookiesAccepted', 'true');
          
          window.location.reload();
          
          const banner = document.getElementById('hs-eu-cookie-confirmation');
          if (banner) {
            banner.remove();
          }
        
          overlay.remove();
        
          document.body.classList.remove('cookie-banner-visible');

          loadHubSpotForm();
        }        

        function attachCookieListeners() {
          const acceptBtn = document.getElementById('hs-eu-confirmation-button');
          const declineBtn = document.getElementById('hs-eu-decline-button');
          if (acceptBtn) acceptBtn.addEventListener('click', hideCookieBanner);
          if (declineBtn) declineBtn.addEventListener('click', hideCookieBanner);
          const confirmBtn = document.getElementById('hs-eu-confirmation-button');
          if (confirmBtn) {
            let leaveBtn = document.getElementById('hs-eu-leave-button');
            if (!leaveBtn) {
              leaveBtn = document.createElement('a');
              leaveBtn.href = 'javascript:void(0);';
              leaveBtn.id = 'hs-eu-leave-button';
              leaveBtn.role = 'button';
              leaveBtn.textContent = 'Nein, Seite verlassen';
              leaveBtn.style.marginRight = '10px';

              confirmBtn.insertAdjacentElement('beforebegin', leaveBtn);

              leaveBtn.addEventListener('click', () => {
                window.open('', '_self');
                window.close();

                setTimeout(() => {
                  window.location.href = 'about:blank';
                }, 100);
              });
            }
          }
        }

        attachCookieListeners();

        const observer = new MutationObserver(attachCookieListeners);
        observer.observe(document.body, { childList: true, subtree: true });
    }
    }, []);
  
  return (
    <Box>
      <Navbar />

      <Box
        sx={{
          padding: isMobile ? '10px' : '20px',
          maxWidth: '800px',
          margin: '0 auto',
        }}
      >
        {/* Header and Image */}
        <Typography variant="h4" gutterBottom sx={{textAlign: 'center'}}>
          Ihr Ansprechpartner
        </Typography>
        <Box textAlign="center">
          <img
            src="/assets/kontakt/Andreas_Metz_round.jpg"
            alt="Andreas Metz"
            style={{ width: '300px', borderRadius: '50%' }}
          />
          <Typography variant="h5" sx={{ marginTop: '10px' }}>
            Andreas Metz
          </Typography>
          <Typography variant="subtitle1">Geschäftsführer</Typography>
        </Box>

        <Typography variant="h5" sx={{ marginTop: '30px', marginBottom: '100px',textAlign: 'center', fontSize:'1.5rem', fontWeight:'bold'}}>
          Jetzt hier Eintragen
        </Typography>

        {/* HubSpot Form Container */}
        <Box
          id="hubspot-form"
          sx={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      </Box>

      <Footer />
    </Box>
  );
};

export default KontaktPage;
